import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../API/apiClient";

export const GetCustomerMaster = createAsyncThunk(
    'CustomerMaster/GetCustomerMaster',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('CustomerMaster/GetCustomerMaster');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetCustomerQRCode = createAsyncThunk(
    'CustomerMaster/GetCustomerQR',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('CustomerMaster/GetTransactionId');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetAdversitment = createAsyncThunk(
    'CustomerMaster/GetAdversitmentImage',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('CustomerMaster/GetAdversitment');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const Getoffers = createAsyncThunk(
    'CustomerMaster/GetoffersShow',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('CustomerMaster/Getoffers');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
 